import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type LiveUpdatePopupType = {
  status: 'active' | 'inactive';
};

export const liveUpdatePopupSlice = createSlice({
  name: 'liveUpdatePopup',
  initialState: { status: '' },
  reducers: {
    setStatus: (state, action: PayloadAction<LiveUpdatePopupType>) => {
      return action.payload;
    },
  },
});

export const { setStatus } = liveUpdatePopupSlice.actions;
export default liveUpdatePopupSlice.reducer;
